import { render, staticRenderFns } from "./LoginSelectBranch.vue?vue&type=template&id=79063487&"
import script from "./LoginSelectBranch.vue?vue&type=script&lang=js&"
export * from "./LoginSelectBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports